<div class="container" *ngIf="rolePermission else noPermission">
    <h4>Product Settings</h4>

    <div class="table">
        <table mat-table [dataSource]="productSettings" class="mat-elevation-z8">
            <ng-container matColumnDef="productLineName">
                <th mat-header-cell *matHeaderCellDef>Product Line Name</th>
                <td mat-cell *matCellDef="let product">{{ product.productLineName }}</td>
            </ng-container>

            <ng-container matColumnDef="whiteListed">
                <th mat-header-cell *matHeaderCellDef>Product Published</th>
                <td mat-cell *matCellDef="let product">
                    <mat-slide-toggle
                        color="warn"
                        [checked]="product['whiteListed']"
                        disabled="true"
                    ></mat-slide-toggle>
                </td>
            </ng-container>

            <ng-container matColumnDef="couponsEnabled">
                <th mat-header-cell *matHeaderCellDef>Coupons Enabled</th>
                <td mat-cell *matCellDef="let product">
                    <mat-slide-toggle
                        color="warn"
                        [checked]="product['couponsEnabled']"
                        disabled="true"
                    ></mat-slide-toggle>
                </td>
            </ng-container>

            <ng-container matColumnDef="displayOnIOS">
                <th mat-header-cell *matHeaderCellDef>Display On IOS</th>
                <td mat-cell *matCellDef="let product">
                    <mat-slide-toggle
                        color="warn"
                        [checked]="product['displayOnIOS']"
                        disabled="true"
                    ></mat-slide-toggle>
                </td>
            </ng-container>
            <ng-container matColumnDef="displayOnAndroid">
                <th mat-header-cell *matHeaderCellDef>Display On Android</th>
                <td mat-cell *matCellDef="let product">
                    <mat-slide-toggle
                        color="warn"
                        [checked]="product['displayOnAndroid']"
                        disabled="true"
                    ></mat-slide-toggle>
                </td>
            </ng-container>

            <ng-container matColumnDef="isGreyedOut">
                <th mat-header-cell *matHeaderCellDef>Gray Out Product</th>
                <td mat-cell *matCellDef="let product">
                    <mat-slide-toggle
                        color="warn"
                        [checked]="product['isGreyedOut']"
                        disabled="true"
                    ></mat-slide-toggle>
                </td>
            </ng-container>

            <ng-container matColumnDef="serviceFee">
                <th mat-header-cell *matHeaderCellDef>Service Fee</th>
                <td mat-cell *matCellDef="let product">
                    <mat-slide-toggle color="warn" [checked]="product['serviceFee']" disabled="true"></mat-slide-toggle>
                </td>
            </ng-container>

            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let product">
                    <button mat-stroked-button class="states" *ngIf="rolePermission" (click)="displayDialog(product)">
                        Edit
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
<ng-template #noPermission>
    <div class="container">Sorry, you don't have read permission.</div>
</ng-template>
